module.exports = __webpack_public_path__ + "img/tanchuan-02.086ca836.svg";